/* eslint-disable no-param-reassign */
import { Grid, makeStyles } from '@material-ui/core';
import { Formik } from 'formik';
import i18n from 'i18n';
import { ClientApplicationsFields } from 'modules/clients/interfaces';
import React from 'react';
import GenericForm from 'skyone-lib/lib/GenericForm';
import Button from 'components/Button';
import Loading from 'components/Loading';
import screenFields from './formFields';
import schema from './schema';
import styles from './styles';

const useStyles = makeStyles(styles);

const init: Pick<ClientApplicationsFields, 'name' | 'state'> = {
  name: '',
  state: 'active',
};

export interface Props {
  initialValues?: ClientApplicationsFields;
  isLoading?: boolean;
  mode: 'simple' | 'advanced';
  onCancel: () => void;
  onSubmit: (values) => void;
}

const FormAddApplication = ({
  initialValues,
  isLoading,
  mode,
  onCancel,
  onSubmit,
}: Props) => {
  const classes = useStyles();

  return (
    <Formik
      initialValues={initialValues || init}
      onSubmit={onSubmit}
      validationSchema={schema[mode]}
      enableReinitialize
    >
      {({ setFieldValue, submitForm, values, errors }) => (
        <Grid spacing={2} container data-testid={'autosky-formaddapplication'}>
          <GenericForm
            fields={values}
            screenFields={screenFields[mode].map(item => {
              if (item.stateKey === 'name' && values.name.length > 50) {
                values.name = values.name.substring(0, 50);
              }
              return {
                ...item,
              };
            })}
            setFieldValue={setFieldValue}
            errors={errors}
          />

          <Grid container justify="flex-end" className={classes.buttonsBase}>
            <Grid container className={classes.buttonsAlign}>
              <Button
                id="submit-button"
                onClick={submitForm}
                disabled={isLoading}
                submitButton
              >
                {isLoading ? <Loading size={15} /> : i18n.t('SAVE_KEY')}
              </Button>
              <Button id="cancel-button" variant="outlined" onClick={onCancel}>
                {i18n.t('CANCEL_KEY')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Formik>
  );
};

export default FormAddApplication;
